const Translations = {
    en: {
        heading: 'Find your true colour match in 90 seconds!',
        subheading: 'Get the perfect colour match for your skintone! No need to spend hours doing research on self-tanners. Just take our quiz, and we’ll do the rest.',
        caption: 'Your perfect shade is just a few clicks away',
        btn: {
            start: 'Find my Match',
            next: 'Next',
            prev: 'Previous Question',
            result: 'See results!',
            skip: 'Skip this step',
            view: 'View my results'
        },
        loading: 'Analysing your answers',
        formEmail: {
            title: 'We found your perfect match!',
            caption: 'Enter your email to save your results!<br/>Plus, get a promo code for <strong>15% OFF</strong> your first purchase.',
            email: 'Email',
            button: 'Submit',
            term: 'I agree to <a target="_blank" href="https://www.cocoandeve.com/pages/privacy-policy">Privacy Policy</a> & <a target="_blank" href="https://www.cocoandeve.com/pages/terms-and-conditions">ToS</a>',
            condition: 'By signing up, you agree to receive exclusive offers via email.\nSign up not required for purchase. Opt out any time.'
        },
        result: {
            title: 'Thanks! Here is your promo code:',
            code: 'QUIZ15',
            note: 'Promo code applies only for first purchases.'
        }
    },
    fr: {
        heading: "Trouvez votre teinte parfaite en 90 secondes !",
        subheading: "Trouvez la teinte parfaite pour votre peau ! Fini les heures passées à chercher le bon autobronzant. Faites simplement notre quiz, et nous nous occupons du reste.",
        caption: "Votre teinte parfaite n'est plus qu'à quelques clics.",
        btn: {
            start: 'Trouver ma teinte',
            next: 'Suivant',
            prev: 'Question précédente',
            result: 'Voir les résultats !',
            skip: 'Skip this step',
            view: 'View my results'
        },
        loading: 'Analyse de vos réponses',
        formEmail: {
            title: 'We found your perfect match!',
            caption: 'Enter your email to save your results!<br/>Plus, get a promo code for <strong>15% OFF</strong> your first purchase.',
            email: 'Email',
            button: 'Submit',
            term: 'I agree to <a target="_blank" href="https://www.cocoandeve.com/pages/privacy-policy">Privacy Policy</a> & <a target="_blank" href="https://www.cocoandeve.com/pages/terms-and-conditions">ToS</a>',
            condition: 'By signing up, you agree to receive exclusive offers via email.\nSign up not required for purchase. Opt out any time.'
        },
        result: {
            title: 'Thanks!\nHere is your promo code:',
            code: 'QUIZ15',
            note: 'Promo code applies only for first purchases.'
        }
    },
    de: {
        heading: "Finde in 90 Sekunden deine perfekte Nuance!",
        subheading: "Finde die perfekte Nuance für deinen Hautton! Du musst nicht stundenlang nach Selbstbräunern suchen. Nimm einfach an unserem Quiz teil und wir erledigen den Rest.",
        caption: 'Deine perfekte Nuance ist nur ein paar Klicks entfernt',
        btn: {
            start: 'Finde meine Nuance',
            next: 'Weiter',
            prev: 'Vorherige Frage',
            result: 'Siehe Ergebnisse!',
            skip: 'Skip this step',
            view: 'View my results'
        },
        loading: 'Analyse deiner Antworten',
        formEmail: {
            title: 'We found your perfect match!',
            caption: 'Enter your email to save your results!<br/>Plus, get a promo code for <strong>15% OFF</strong> your first purchase.',
            email: 'Email',
            button: 'Submit',
            term: 'I agree to <a target="_blank" href="https://www.cocoandeve.com/pages/privacy-policy">Privacy Policy</a> & <a target="_blank" href="https://www.cocoandeve.com/pages/terms-and-conditions">ToS</a>',
            condition: 'By signing up, you agree to receive exclusive offers via email.\nSign up not required for purchase. Opt out any time.'
        },
        result: {
            title: 'Thanks! Here is your promo code:',
            code: 'QUIZ15',
            note: 'Promo code applies only for first purchases.'
        }
    }
}

export default Translations;
